/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoIntolleranzaCreateDTO
 */
export interface AssistitoIntolleranzaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaCreateDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaCreateDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoIntolleranzaCreateDTO interface.
 */
export function instanceOfAssistitoIntolleranzaCreateDTO(value: object): value is AssistitoIntolleranzaCreateDTO {
    return true;
}

export function AssistitoIntolleranzaCreateDTOFromJSON(json: any): AssistitoIntolleranzaCreateDTO {
    return AssistitoIntolleranzaCreateDTOFromJSONTyped(json, false);
}

export function AssistitoIntolleranzaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoIntolleranzaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoIntolleranzaCreateDTOToJSON(value?: AssistitoIntolleranzaCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

